import { render, staticRenderFns } from "./AccidentCard.vue?vue&type=template&id=c1ca4416"
import script from "./AccidentCard.vue?vue&type=script&lang=js"
export * from "./AccidentCard.vue?vue&type=script&lang=js"
import style0 from "./AccidentCard.vue?vue&type=style&index=0&id=c1ca4416&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports